import React from 'react';
import {getMessage} from '../utils/messages';

export type MonthYearSelectorProps = {
	month: number;
	year: number;
	monthNames: string[];
	onMonthChange: (month: number) => void;
	onYearChange: (year: number) => void;
};

export const MonthYearSelector: React.FC<MonthYearSelectorProps> = ({
																		month,
																		year,
																		monthNames,
																		onMonthChange,
																		onYearChange,
																	}) => (
	<div className="row">
		<div className="col-sm-6 col-md-4 col-lg-3">
			<div className="form-group">
				<label className="text-muted">{getMessage('report.timespan.MONTH')}</label>
				<select
					className="form-control"
					value={month}
					onChange={event => onMonthChange(Number(event.target.value))}
				>
					{monthNames.map((name, index) => (
						<option key={name} value={index + 1}>{name}</option>
					))}
				</select>
			</div>
		</div>
		<div className="col-sm-6 col-md-4 col-lg-3">
			<div className="form-group">
				<label className="text-muted">{getMessage('report.timespan.YEAR')}</label>
				<select
					className="form-control"
					value={year}
					onChange={event => onYearChange(Number(event.target.value))}
				>
					{/* List years in reverse so current year is on top */}
					{Array.from({length: new Date().getFullYear() - 2000 + 1}, (_, i) => 2000 + i)
						.reverse()
						.map(y => (
							<option key={y} value={y}>{y}</option>
						))}
				</select>
			</div>
		</div>
	</div>
);
